import { Row } from "native-base";

export default Row;